<template>
  <div>
    <mdb-modal @shown="componentDidMount" :show="visible" @close="hideModal">
      <mdb-modal-header>
        <mdb-modal-title>Operating Hour</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row v-if="loading">
            <mdb-col col="12" class="d-flex flex-center">
                <mdb-spinner />
            </mdb-col>
        </mdb-row>
        <mdb-container v-if="!loading">
        <mdb-row v-for="(day, index) in operating_hours" class="mb-5" :key="day.id">
            <mdb-col col="4">
                {{day.day}}
            </mdb-col>
            <mdb-col col="8">
                <mdb-row>
                    <mdb-col col="6">
                        <div class="custom-control custom-switch" @click="toggleAvailable(day, index)">
                            <input type="checkbox" class="custom-control-input" v-model="day.is_available">
                            <label class="custom-control-label">Available</label>
                        </div>
                    </mdb-col>
                    <mdb-col col="6">
                        <div class="custom-control custom-switch" @click="toggleFullDay(day, index)">
                            <input type="checkbox" class="custom-control-input" v-model="day.full_day">
                            <label class="custom-control-label">24 Hours</label>
                        </div>
                    </mdb-col>
                </mdb-row>
                <mdb-row v-for="(slot) in day.operating_slots" class="mb-2" v-bind:key="slot.id+'-slot'">
                    <mdb-col col="6">
                        <select :disabled="day.is_available!=1 || day.full_day==1" v-model="slot.from" class="browser-default custom-select">
                            <option selected disabled :value="slot.from">{{slot.from}}</option>
                            <option v-for="time in hours_selection" v-bind:key="time" :value="time">{{time}}</option>
                        </select>
                    </mdb-col>
                    <mdb-col col="6">
                        <select :disabled="day.is_available!=1 || day.full_day==1" v-model="slot.to" class="browser-default custom-select">
                            <option selected disabled :value="slot.to">{{slot.to}}</option>
                            <option v-for="time in hours_selection" v-bind:key="time" :value="time">{{time}}</option>
                        </select>
                    </mdb-col>
                </mdb-row>
                <mdb-row v-if="day.is_available==1 && day.full_day!=1">
                    <mdb-col col="12">
                        <mdb-btn v-if="day.operating_slots.length==1" size="sm" @click="addOperatingSlot(index)" color="primary">Add {{day.day}} Slot</mdb-btn>
                        <mdb-btn v-if="day.operating_slots.length==2" size="sm" @click="removeOperatingSlot(index)" color="danger">Remove {{day.day}} Slot</mdb-btn>
                    </mdb-col>
                </mdb-row>
            </mdb-col>
        </mdb-row>
        </mdb-container>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="action_loading" class="p-0 m-0" small color="blue"/>
        <mdb-btn color="primary" v-if="!action_loading && checkPermission(70)" @click="updateOperatingHour">Update</mdb-btn>
        <mdb-btn color="secondary" v-if="!action_loading" @click.native="hideModal">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbContainer, mdbRow, mdbCol, mdbSpinner } from 'mdbvue';
  import {ajax} from '../js/ajax';
  import {checkPermissionsBinary, time15minsInterval} from '../js/helper';

  export default {
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn, mdbContainer, mdbRow, mdbCol,
      mdbSpinner
    },
    props: ['visible', 'close', 'merchant_id'],
    data: ()=>({
        loading:true,
        operating_hours: [],
        action_loading:false,
        hours_selection: time15minsInterval()
    }),
    methods: {
        getData(){
            this.loading=true;
            ajax({
                url: "admin/get_operating_hour",
                data: {
                    id: this.merchant_id,
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    result.data.forEach(element => {
                        element.operating_slots.forEach(slot => {
                            slot.from=slot.from.slice(0,5);
                            slot.to=slot.to.slice(0,5);
                        });
                    });
                    this.operating_hours=result.data;
                },
            })
        },
        componentDidMount(){
            this.getData();
        },

        checkPermission(permission){
            return checkPermissionsBinary(permission, this.$store.state.permissions)
        },
        updateOperatingHour(){
            if(!checkPermissionsBinary(70, this.$store.state.permissions)){
                this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
                return;
            }
            if(this.action_loading){
                return false;
            }
            this.action_loading=true;
            let pass=true;
            let message="";
            this.operating_hours.forEach(element => {
                //need loop slot to find out the time overlapping
                if(element.is_available && !element.full_day){
                    element.operating_slots.forEach((slot, index) => {
                        if(!slot.from || !slot.to){
                            pass=false;
                            message=`${element.day} Time cannot be empty`;
                        }
                        if(slot.from >= slot.to){
                            pass=false;
                            message=`${element.day} Slot ${index+1}: Time From cannot be greater than Time to`;
                        }
                    });
                }
            });
            if(!pass){
                this.$notify.error({message: message, position: 'top right', timeOut: 5000});
                this.action_loading=false;
                return false;
            }
            ajax({
                url: "admin/update_operating_hour",
                data: {
                    operating_hour: this.operating_hours,
                },
                complete: ()=>this.action_loading=false,
                success: ()=>{
                    this.$notify.success({message: 'Operating Hours has been updated.', position:'top right', timeOut: 5000});
                    this.close();
                    
                },
            })
        },
        hideModal(){
            this.operating_hours=[];
            this.loading=true;
            this.close();
        },
        toggleAvailable(day, index){
            let temp=[...this.operating_hours];
            temp[index].is_available=temp[index].is_available==0?1:0;
            this.operating_hours=temp;
        },
        toggleFullDay(day, index){
            let temp=[...this.operating_hours];
            temp[index].full_day=temp[index].full_day==0?1:0;
            this.operating_hours=temp;
        },
        addOperatingSlot(index){
            let temp=[...this.operating_hours];
            let operating_slots=temp[index].operating_slots;
            let new_slot={
                from: "00:00",
                to: "00:00"
            }
            operating_slots.push(new_slot);
            temp[index].operating_slots=operating_slots;
            this.operating_hours=temp;
        },
        removeOperatingSlot(index){
            let temp=[...this.operating_hours];
            let operating_slots=temp[index].operating_slots;            
            if(operating_slots.length>1 && operating_slots[1].id){
                ajax({
                    url: "admin/delete_operating_slot",
                    data: {
                        id: operating_slots[1].id
                    },
                    complete: ()=>this.action_loading=false,
                    success: ()=>{
                        this.$notify.success({message: 'Operating Slot Deleted.', position:'top right', timeOut: 5000});
                        operating_slots.splice(1, 1);
                        temp[index].operating_slots=operating_slots;
                        this.operating_hours=temp;
                    },
                })
            }else{
                operating_slots.splice(1, 1);
                temp[index].operating_slots=operating_slots;
                this.operating_hours=temp;
            }            
        }
    },
  };
</script>

<style scoped>
.link{
    color: #2196f3;
    cursor: pointer;
    font-size: 8;
}
.link:hover{
    color: #283593;
    font-size: 8;
}
</style>